import * as drivingData from '../../util/drivingData';

//Per adult logic as per https://carbonclick.atlassian.net/browse/CC-2495
export const vehicleCalculation = ({question, answers, calculateForOneAdult}) =>{
  const kms =  answers.DRIVING[0].yearlyDistance?.value * ( question.unit ==='km' ? 1 : 1.60934);

  const co2kgs = drivingData.getResultForYear(answers.DRIVING[0].size + '-' + answers.DRIVING[0].fuel, kms / 52).co2;

  return co2kgs/1000  / (calculateForOneAdult ? answers.HOUSEHOLD.adults : 1);
}

export const energyCalculation = ({question, answers, calculateForOneAdult}) =>{
  if (answers.ENERGY.hasCarbonNeutralEnergy) {
    return 0;
  } else {
    return answers.ENERGY.monthlySpend.value * question.multiplier / (calculateForOneAdult ? answers.HOUSEHOLD.adults : 1);
  }
}

export const unavoidableCalculation = ({question, answers, calculateForOneAdult}) =>{
  return question.multiplier * (calculateForOneAdult ? 1 : (answers.HOUSEHOLD.adults+answers.HOUSEHOLD.children));
}

export const dietCalculation = ({answers, calculateForOneAdult}) =>{
  let baseAmount = answers.DIET.yearlyCarbonFootprintOneAdult.value;

  return householdCalculation({
    baseAmount,
    numAdults: answers.HOUSEHOLD.adults,
    numChildren: answers.HOUSEHOLD.children,
    calculateForOneAdult
  });
}

export const wasteCalculation = ({question, answers, calculateForOneAdult}) =>{
  let baseAmount = answers.WASTE.yearlyProducedOneAdult.value * question.multiplier;

  return householdCalculation({
    baseAmount,
    numAdults: answers.HOUSEHOLD.adults,
    numChildren: answers.HOUSEHOLD.children,
    calculateForOneAdult
  });
}

export const flightCalculation = ({question, answers, calculateForOneAdult}) =>{
  return answers.FLIGHTS[question.alias]*question.multiplier  / (calculateForOneAdult ? (answers.HOUSEHOLD.adults+answers.HOUSEHOLD.children) : 1);
}

//https://carbonclick.atlassian.net/browse/CC-1126
//https://docs.google.com/spreadsheets/d/1_1jh54FUs5EneCKQQRQvqxknTsb71O_5whFn_SjsI58/edit#gid=0
//Tough to make something that covers all this, but that chart broadly shows that for each extra adult
//in a household there's a 10% saving in per person footprint up to 4 people
export const householdCalculation = ({baseAmount, numAdults, numChildren, calculateForOneAdult}) =>{
  let amountPerAdult;
  if(numAdults<=1){
    amountPerAdult=baseAmount;
  }
  else{
    amountPerAdult = baseAmount * (1- getDiscountRatio(numAdults));
  }

  let householdAmount = amountPerAdult*numAdults + baseAmount*numChildren*0.2;

  return calculateForOneAdult ? amountPerAdult : householdAmount;
}

export const getDiscountRatio = (numAdults) => {
  const discountPerExtraPerson=10;
  const discountPersonCap=4;

  return Math.min(numAdults-1,discountPersonCap-1)/100*discountPerExtraPerson;
}

export const calculateFootprint = ({questions, answers, calculateForOneAdult}) => {
  const footprint = {
    DIET: 0.0,
    ENERGY: 0.0,
    WASTE: 0.0,
    DRIVING: 0.0,
    FLIGHTS: 0.0,
    UNAVOIDABLE: 0.0
  };

  for (const questionAlias in questions.questions) {
    const question = questions.questions[questionAlias];
    if(question.rootAlias && footprint[question.rootAlias]!=undefined){
        const co2Amount = question.calcFunction({question,answers,calculateForOneAdult});

        footprint[question.rootAlias] = footprint[question.rootAlias] + co2Amount;
    }
}

return footprint;
}
